import PropTypes from 'prop-types';
import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { AuthContext } from 'src/auth/context';
import { LoadingScreen } from 'src/components/loading-screen';
import { paths } from 'src/routes/paths';

const allowedAdminRoles = ['admin'];

const AdminGuard = ({ children }) => {
  const { loading, admin, isAdminAuthenticated } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return <LoadingScreen />;
  }

  const hasAdminAccess = isAdminAuthenticated && admin && allowedAdminRoles.includes(admin.role);

  if (!hasAdminAccess) {
    return <Navigate to={paths.admin.login} replace state={{ from: location }} />;
  }

  return children;
};

AdminGuard.propTypes = {
  children: PropTypes.node,
};

export default AdminGuard;
